const set = require('regenerate')(0x951, 0x1CE9, 0x1CF2, 0x1CFA);
set.addRange(0x964, 0x965).addRange(0xCE6, 0xCEF).addRange(0xA830, 0xA835).addRange(0x119A0, 0x119A7).addRange(0x119AA, 0x119D7).addRange(0x119DA, 0x119E4);
exports.characters = set;
